<template>
	<div>

		<v-row>
			<v-col class="d-flex align-center">
				<v-badge
					v-if="isAccountManager"
					:value="thereAreFiltersApplied"
					color="primary"
					overlap
					right
					class="mr-4"
				>
					<v-btn
						color="secondary"
						@click="openFiltersDialog()"
						:disabled="isLoading"
					>
						Filtri
					</v-btn>
				</v-badge>

				<v-badge
					v-if="isAccountManager && accordoId === null && contrattoDiServizioId === null"
					:value="computedAccountManagersIds?.length > 0"
					class="mr-4"
					color="primary"
					overlap
					right
				>
					<v-btn
						color="secondary"
						@click="openAccountManagersTreeviewDialog()"
						:disabled="isLoading"
					>
						Seleziona Account Managers
					</v-btn>
				</v-badge>
			</v-col>

				<v-col cols="4">
					<v-text-field
						v-model="search"
						append-icon="mdi-magnify"
						label="Cerca"
						single-line
						hide-details
						outlined
						dense
					></v-text-field>
				</v-col>

			<v-col class="d-flex justify-end">
				<v-menu
					bottom
					:disabled="isLoading"
					v-if="user?.account_manager?.cambio_stato_fasi_in_massa_abilitato"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							color="secondary"
							v-bind="attrs"
							v-on="on"
							:disabled="isLoading"
						>
							Azioni in massa
						</v-btn>
					</template>

					<v-list>
						<v-list-item @click="openCambioStatoInMassaDialog()">
							<v-list-item-title>Stato Fasi</v-list-item-title>
						</v-list-item>
						<v-list-item @click="openCambioScreenshotDelClickInMassaDialog">
							<v-list-item-title>Descrizione Screenshot Schermata del Click</v-list-item-title>
						</v-list-item>
						<v-list-item @click="openAggiungiTagPraticaInMassaDialog">
							<v-list-item-title>Tag pratica</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</v-col>

			<!-- visibile solo all'account di Lucia -->
			<v-col v-if="bottoneAssegnazioneInMassaVisibile">
				<v-btn
					color="secondary"
					@click="openAssegnazioneCliccatoriInMassaDialog()"
					:disabled="isLoading"
				>
					Assegnazione in massa
				</v-btn>
			</v-col>

			<!--<v-col v-if="isAccountManager && accordoId === null && contrattoDiServizioId === null">-->
			<!--	<v-btn-->
			<!--		color="secondary"-->
			<!--		@click="openAccountManagersTreeviewDialog()"-->
			<!--		:disabled="isLoading"-->
			<!--	>-->
			<!--		Seleziona Account Managers-->
			<!--	</v-btn>-->
			<!--</v-col>-->

			<!--<v-col cols="0" md="3">-->
			<!--</v-col>-->
		</v-row>

		<v-row>
			<v-col>
				<pratiche-data-table
					ref="praticheDataTable"
					:search="search"
					:accordo-id="accordoId"
					:contratto-di-servizio-id="contrattoDiServizioId"
					:fasi-with-stati="fasiWithStati"
					@is-loading="isLoadingPraticheDataTable = $event"
					@reload-accordi="$emit('reload-accordi')"
					@reload-contratti-di-servizio="$emit('reload-contratti-di-servizio')"
				></pratiche-data-table>
			</v-col>
		</v-row>

		<v-dialog
			v-model="accountManagersTreeviewDialog"
			persistent
			max-width="700"
			scrollable
		>
			<account-managers-treeview
				:key="accountManagersTreeviewDialogKey"
				@apply="applyAccountManagersFilter()"
				@close="accountManagersTreeviewDialog = false"
			></account-managers-treeview>
		</v-dialog>

		<v-dialog
			v-model="cambioStatoInMassaDialog"
			persistent
			max-width="700"
			scrollable
		>
			<cambio-stato-in-massa
				:key="cambioStatoInMassaDialogKey"
				:pratiche-ids="praticheIds"
				@done="$refs.praticheDataTable.reloadPratiche()"
				@close="cambioStatoInMassaDialog = false"
			></cambio-stato-in-massa>
		</v-dialog>

		<v-dialog
			v-model="assegnazioneCliccatoriInMassaDialog"
			persistent
			width="auto"
			scrollable
		>
			<assegnazione-cliccatori-in-massa
				:key="assegnazioneCliccatoriInMassaDialogKey"
				:pratiche-ids="praticheIdsPerAssegnazioneCliccatoriInMassa"
				@done="$refs.praticheDataTable.reloadPratiche()"
				@close="assegnazioneCliccatoriInMassaDialog = false"
			></assegnazione-cliccatori-in-massa>
		</v-dialog>

		<v-dialog
			v-model="cambioScreenshotDelClickInMassaDialog"
			persistent
			width="auto"
			scrollable
		>
			<cambio-descrizione-screenshot-del-click-in-massa
				:key="cambioScreenshotDelClickInMassaDialogKey"
				:pratiche-ids="praticheIds"
				@done="$refs.praticheDataTable.reloadPratiche()"
				@close="cambioScreenshotDelClickInMassaDialog = false"
			></cambio-descrizione-screenshot-del-click-in-massa>
		</v-dialog>

		<v-dialog
			v-model="aggiungiTagPraticaInMassaDialog"
			persistent
			width="auto"
			scrollable
		>
			<aggiungi-tag-pratica-in-massa
				:key="aggiungiTagPraticaInMassaDialogDialogKey"
				:pratiche-ids="praticheIds"
				@done="$refs.praticheDataTable.reloadPratiche()"
				@close="aggiungiTagPraticaInMassaDialog = false"
			></aggiungi-tag-pratica-in-massa>
		</v-dialog>

	</div>
</template>

<script>
import { saveAs } from 'file-saver';
import {mapActions, mapGetters, mapMutations} from "vuex";
import {eventBus} from "@/event-bus";
export default {
	props: {
		accordoId: { // quando nella pagina Accordi si apre il v-dialog con le pratiche di quell'accordo
			default: null
		},
		contrattoDiServizioId: { // quando nella pagina Contratti di servizio si apre il v-dialog con le pratiche di quel contratto
			default: null
		},
	},
	data() {
		return {
			accountManagersTreeviewDialog: false,
			accountManagersTreeviewDialogKey: 0,

			isLoadingPraticheDataTable: false,
			search: null,

			cambioStatoInMassaDialog: false,
			cambioStatoInMassaDialogKey: 0,
			praticheIds: [],

			assegnazioneCliccatoriInMassaDialog: false,
			assegnazioneCliccatoriInMassaDialogKey: 0,
			praticheIdsPerAssegnazioneCliccatoriInMassa: [],

			cambioScreenshotDelClickInMassaDialog: false,
			cambioScreenshotDelClickInMassaDialogKey: 0,

			aggiungiTagPraticaInMassaDialog: false,
			aggiungiTagPraticaInMassaDialogDialogKey: 0
		};
	},

	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			fasiWithStati: 'fasi/fasiWithStati',
			thereAreFiltersApplied: 'praticheFilters/thereAreFiltersApplied',
			accountManagersIds: 'sharedFilters/accountManagersIds',
			user: 'auth/user'
		}),
		computedAccountManagersIds: {
			get: function () {
				return this.accountManagersIds.value;
			},
			set: function (value) {
				// if (value?.length === 0) value = null;
				this.setAccountManagersIdsNotApplied(value);
			}
		},
		isLoading() {
			return this.isLoadingPraticheDataTable;
		},
		bottoneAssegnazioneInMassaVisibile() {
			return this.user?.account_manager?.id == 5
				|| this.user?.account_manager?.id == 1
				|| this.user?.account_manager?.id == 4
        || this.user?.account_manager?.id == 3
		}
	},

	methods: {
		...mapMutations({
			setClientiIdsToDefault: 'praticheFilters/SET_CLIENTI_IDS_TO_DEFAULT',
			setAccountManagersIdsNotApplied: 'sharedFilters/SET_ACCOUNT_MANAGERS_IDS_NOT_APPLIED',
			setAccountManagersIdsApplied: 'sharedFilters/SET_ACCOUNT_MANAGERS_IDS_APPLIED',
		}),
		...mapActions({
			salvaImpostazioniAmAction: 'shared/salvaImpostazioniAm',
		}),
		openFiltersDialog() {
			this.$refs.praticheDataTable.openPraticheFilters();
		},
		openAccountManagersTreeviewDialog() {
			this.accountManagersTreeviewDialogKey++;
			this.accountManagersTreeviewDialog = true;
		},
		applyAccountManagersFilter() {
			// accountManagersIds lo passo via prop
			this.setClientiIdsToDefault();
			this.setAccountManagersIdsApplied(this.accountManagersIds.valueNonApplied);
			this.salvaImpostazioniAmAction();
			this.$refs.praticheDataTable.reloadPratiche();
			this.$refs.praticheDataTable.praticheFiltersKey++;
			this.accountManagersTreeviewDialog = false;
		},
		openCambioStatoInMassaDialog() {
			this.praticheIds = this.$refs.praticheDataTable.pratiche.map(p => p['id']);
			this.cambioStatoInMassaDialogKey++;
			this.cambioStatoInMassaDialog = true;
		},
		openAssegnazioneCliccatoriInMassaDialog() {
			this.praticheIdsPerAssegnazioneCliccatoriInMassa = this.$refs.praticheDataTable.praticheFiltrate.map(p => p['id']);
			this.assegnazioneCliccatoriInMassaDialogKey++;
			this.assegnazioneCliccatoriInMassaDialog = true;
		},
		openCambioScreenshotDelClickInMassaDialog() {
			this.praticheIds = this.$refs.praticheDataTable.pratiche.map(p => p['id']);
			this.cambioScreenshotDelClickInMassaDialogKey++;
			this.cambioScreenshotDelClickInMassaDialog = true;
		},
		openAggiungiTagPraticaInMassaDialog() {
			this.praticheIds = this.$refs.praticheDataTable.pratiche.map(p => p['id']);
			this.aggiungiTagPraticaInMassaDialogDialogKey++;
			this.aggiungiTagPraticaInMassaDialog = true;
		}
	},
};
</script>
